'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require('@babel/runtime/helpers/extends'));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require('@babel/runtime/helpers/objectWithoutPropertiesLoose'));

var _classnames = _interopRequireDefault(require('classnames'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _elementType = _interopRequireDefault(require('prop-types-extra/lib/elementType'));

var _react = _interopRequireDefault(require('react'));

var _SafeAnchor = _interopRequireDefault(require('./SafeAnchor'));

var _AbstractNavItem = _interopRequireDefault(require('./AbstractNavItem'));

var _ThemeProvider = require('./ThemeProvider');

var propTypes = {
  /**
   * @default 'nav-link'
   */
  bsPrefix: _propTypes.default.string,

  /**
   * The active state of the NavItem item.
   */
  active: _propTypes.default.bool,

  /**
   * The disabled state of the NavItem item.
   */
  disabled: _propTypes.default.bool,

  /**
   * The ARIA role for the `NavLink`, In the context of a 'tablist' parent Nav,
   * the role defaults to 'tab'
   * */
  role: _propTypes.default.string,

  /** The HTML href attribute for the `NavLink` */
  href: _propTypes.default.string,

  /** A callback fired when the `NavLink` is selected.
   *
   * ```js
   * function (eventKey: any, event: SyntheticEvent) {}
   * ```
   */
  onSelect: _propTypes.default.func,

  /**
   * Uniquely idenifies the `NavItem` amoungst its siblings,
   * used to determine and control the active state ofthe parent `Nav`
   */
  eventKey: _propTypes.default.any,

  /** @default 'a' */
  as: _elementType.default,

  /** @private */
  onClick: _propTypes.default.func
};
var defaultProps = {
  disabled: false,
  as: _SafeAnchor.default
};

function NavLink(_ref) {
  var bsPrefix = _ref.bsPrefix,
    disabled = _ref.disabled,
    className = _ref.className,
    href = _ref.href,
    eventKey = _ref.eventKey,
    onSelect = _ref.onSelect,
    innerRef = _ref.innerRef,
    as = _ref.as,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ['bsPrefix', 'disabled', 'className', 'href', 'eventKey', 'onSelect', 'innerRef', 'as']);
  return _react.default.createElement(_AbstractNavItem.default, (0, _extends2.default)({}, props, {
    href,
    ref: innerRef,
    eventKey,
    as,
    disabled,
    onSelect,
    className: (0, _classnames.default)(className, bsPrefix, disabled && 'disabled')
  }));
}

NavLink.propTypes = propTypes;
NavLink.defaultProps = defaultProps;

var _default = (0, _ThemeProvider.createBootstrapComponent)(NavLink, 'nav-link');

exports.default = _default;
module.exports = exports['default'];



// WEBPACK FOOTER //
// ./app/praece-react-bootstrap/lib/NavLink.js